<footer class="fui-layout-pad-content p-y-50">
  <div class="d-flex flex-wrap">
    <a class="footer-link" href="https://www.fender.com/pages/privacy-portal" target="_blank">Privacy Policy</a>
    <a class="footer-link" href="https://www.fender.com/pages/terms-of-use" target="_blank">Terms of Use</a>
    <a class="footer-link" href="https://www.fender.com/pages/fender-supply-chain-transparency" target="_blank">Supply Chain Transparency</a>
    <a class="footer-link" href="https://www.fender.com/pages/fender-accessibility-statement" target="_blank">Accessibility statement</a>
    <a class="footer-link" href="https://www.fender.com/pages/fender-competition-law" target="_blank">Competition Law</a>
    <a class="footer-link" href="https://www.fender.com/pages/fender-unsolicited-ideas-submission-policy" target="_blank">Unsolicited ideas submission policy</a>
  </div>
  <div class="m-t-20">Copyright ©{{ year }} Fender Musical Instruments Corporation. All Rights Reserved.</div>
</footer>
